import React from 'react'
import { Environment, RespondAppCore } from 'pulsepoint-web-common'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AppSkeleton, { ConfirmationDialogContext, ScreenWidthCategoryContext, ToastContext } from 'app/common/AppSkeleton'

const Home = () => {
  const [urlParams, setUrlParams] = useSearchParams()
  const navigate = useNavigate()
  const token = urlParams.get('sandbox-token')
  const isSandbox = token !== null && token !== ''
  const context = isSandbox ? 'SANDBOX_LINK' : 'PUBLIC'
  const allowedEnvironments: Environment[] = isSandbox ? ['SANDBOX'] : ['PRODUCTION']

  const isInIframe = window.self !== window.top
  const hasAgencyParam = urlParams.get('agencies') !== null || urlParams.get('agencyid') !== null

  return (
    <AppSkeleton>
      <ScreenWidthCategoryContext.Consumer>
        {screenWidthCategory => (
          <ToastContext.Consumer>
            {toastManager => (
              <ConfirmationDialogContext.Consumer>
                {dialogManager => (
                  <RespondAppCore
                    searchParams={urlParams}
                    contextProviders={{
                      screenWidthCategory: screenWidthCategory,
                      toastManager: toastManager,
                      confirmationManager: dialogManager,
                    }}
                    appConfiguration={{
                      context: context,
                      isEmbedded: urlParams.get('embed') === '1' || (isInIframe && hasAgencyParam),
                      allowedEnvironments: allowedEnvironments,
                      showPublicPrivateOverrideControl: false
                    }}
                    onSelectAgency={agency => {
                      navigate(`/agency/${agency.agencyID}`, {
                        state: {
                          agency: agency
                        }
                      })
                    }}
                    onSelectIncident={incident => {
                      if (!urlParams.get('incident')) {
                        setUrlParams(prev => {
                          prev.set('incident', incident.recordID)
                          prev.set('agencies', incident.agencyID)
                          return prev
                        })
                      }
                    }}
                  />
                )}
              </ConfirmationDialogContext.Consumer>
            )}
          </ToastContext.Consumer>
        )}
      </ScreenWidthCategoryContext.Consumer>
    </AppSkeleton>
  )
}

export default Home
